import { render, staticRenderFns } from "./InfoSubTitle.vue?vue&type=template&id=4593b7d0&scoped=true&"
import script from "./InfoSubTitle.vue?vue&type=script&lang=js&"
export * from "./InfoSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./InfoSubTitle.vue?vue&type=style&index=0&id=4593b7d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4593b7d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4593b7d0')) {
      api.createRecord('4593b7d0', component.options)
    } else {
      api.reload('4593b7d0', component.options)
    }
    module.hot.accept("./InfoSubTitle.vue?vue&type=template&id=4593b7d0&scoped=true&", function () {
      api.rerender('4593b7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/TouchPointInfo/InfoSubTitle.vue"
export default component.exports